import React, { FC } from 'react';
import { Subscription } from '../../../common/model/dto/subscription';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import OvListTable from '../atoms/OvListTable';
import OvListTableRow from '../atoms/OvListTableRow';
import OvListTableHeaderField from '../atoms/OvListTableHeaderField';
import OvSubscriptionListRow from './OvSubscriptionListRow';

interface OvSubscriptionListProps {
  subscriptions: Subscription[];
}

const OvSubscriptionList: FC<OvSubscriptionListProps> = ({ subscriptions }) => {
  const { t } = useTranslation();

  return (
    <WrapperBox>
      <OvListTable>
        <thead>
          <OvListTableRow>
            <OvListTableHeaderField>
              {t('subscriptions.isActive')}
            </OvListTableHeaderField>
            <OvListTableHeaderField>
              {t('subscriptions.startedAt')}
            </OvListTableHeaderField>
            <OvListTableHeaderField>
              {t('subscriptions.canceledAt')}
            </OvListTableHeaderField>
            <OvListTableHeaderField>
              {t('subscriptions.createdAt')}
            </OvListTableHeaderField>
            <OvListTableHeaderField>
              {t('subscriptions.latestInvoice')}
            </OvListTableHeaderField>
            <OvListTableHeaderField style={{ textAlign: 'center' }}>
              {t('common.operation')}
            </OvListTableHeaderField>
          </OvListTableRow>
        </thead>

        <tbody>
          {subscriptions.map((subscription) => (
            <OvListTableRow key={subscription.id}>
              <OvSubscriptionListRow subscription={subscription} />
            </OvListTableRow>
          ))}
        </tbody>
      </OvListTable>
    </WrapperBox>
  );
};

export default OvSubscriptionList;

const WrapperBox = styled.div`
  padding: 1.5rem 1rem 1rem;
  overflow-x: auto;
`;
